import script from "./KLiquidGlass.vue?vue&type=script&setup=true&lang=ts"
export * from "./KLiquidGlass.vue?vue&type=script&setup=true&lang=ts"

import "./KLiquidGlass.vue?vue&type=style&index=0&id=7a28ecd2&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a28ecd2"]])

export default __exports__